import React, { useState } from 'react';

import CalendarRow from 'Public/graphics/fiftyTwoThings/calendar_row.png';

import { ButtonProps } from 'Elements/Button';

import {
    Container,
    StyledImage,
    Heading,
    StyledButton,
    PhoneButton
} from './LoadPreviousButton.styled';

export interface Props {
    heading: string;
    button: ButtonProps;
}

const LoadPreviousButton: React.FC<Props> = props => {
    const { heading, button } = props;

    const [isHovering, setIsHovering] = useState(false);

    return (
        <Container $isHovering={isHovering}>
            <Heading>{heading}</Heading>
            <StyledImage src={CalendarRow} alt="row of 5 calendars" $isHovering={isHovering} />
            <StyledButton
                {...button}
                onMouseOver={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                onFocus={() => setIsHovering(true)}
                onBlur={() => setIsHovering(false)}
            />
            <PhoneButton type="button" onClick={button.onClick}>
                {heading}
            </PhoneButton>
        </Container>
    );
};

export default LoadPreviousButton;
